import { render, staticRenderFns } from "./ColorFieldBackground.vue?vue&type=template&id=ffd7affa&"
import script from "./ColorFieldBackground.vue?vue&type=script&lang=js&"
export * from "./ColorFieldBackground.vue?vue&type=script&lang=js&"
import style0 from "./ColorFieldBackground.vue?vue&type=style&index=0&id=ffd7affa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports